<template>
  <div class="terms-page">
    <div class="terms-container">
      <b-card class="terms-card">
        <b-link class="brand-logo">
          <img
            src="../../../assets/images/logo/logo.svg"
            class="logo-size"
          >
        </b-link>

        <h4 class="mb-1">
          Termos e condições
        </h4>

        <p>
          Leia o contrato e confirme seu aceite para continuar.
        </p>

        <div
          v-if="reviewTermsEcs.length"
          class="ecs-list mb-2"
        >
          <span class="ecs-label">Empresas vinculadas ao aceite:</span>
          <b-badge
            v-for="ecs in reviewTermsEcs"
            :key="ecs.veripag_id"
            variant="light-primary"
            class="ecs-badge"
          >
            {{ ecs.soft_descriptor }} ({{ ecs.tax_id | tax_id }})
          </b-badge>
        </div>

        <div class="terms-content mb-2">
          <terms />
        </div>

        <b-form-checkbox
          v-model="termsAccepted"
          class="mb-2"
        >
          Li e estou de acordo com os termos e condições da SoulPay.
        </b-form-checkbox>

        <div
          v-if="errorMessage"
          class="text-danger text-center mb-1"
        >
          {{ errorMessage }}
        </div>

        <b-button
          variant="primary"
          block
          :disabled="!termsAccepted || loading"
          @click="accept"
        >
          {{ loading ? 'Enviando...' : 'Aceitar e continuar' }}
        </b-button>
      </b-card>
    </div>
  </div>
</template>

<script>
import {
  BButton,
  BCard,
  BBadge,
  BFormCheckbox,
  BLink,
} from 'bootstrap-vue'
import Terms from './TermsAndConditions.vue'
import { acceptTerms } from '@/service/user/user'
import { getIpAndBrowser } from '@/service/utilities/fingerprint'
import { callLoading, removeDarkMode } from '@/service/utilities/utilities'

export default {
  components: {
    BButton,
    BCard,
    BBadge,
    BFormCheckbox,
    BLink,
    Terms,
  },
  data() {
    return {
      termsAccepted: false,
      loading: false,
      errorMessage: null,
      reviewTermsEcs: [],
    }
  },
  created() {
    removeDarkMode()

    try {
      const storedEcs = JSON.parse(sessionStorage.getItem('reviewTermsEcs') || '[]')
      this.reviewTermsEcs = Array.isArray(storedEcs) ? storedEcs : []
    } catch (error) {
      this.reviewTermsEcs = []
    }
  },
  methods: {
    async accept() {
      this.loading = true
      this.errorMessage = null
      callLoading(true)

      try {
        const { ip, browser } = await getIpAndBrowser()
        const response = await acceptTerms({
          email: sessionStorage.getItem('userEmail'),
          tax_id: sessionStorage.getItem('userTaxId'),
          review_terms_ecs: this.reviewTermsEcs,
          ip,
          browser,
          terms_agreed: true,
        })

        if (response?.status !== 200) {
          this.errorMessage = 'Não foi possível registrar o aceite. Tente novamente.'
          return
        }

        sessionStorage.setItem('termsAccepted', 'true')
        sessionStorage.removeItem('redirectAfterLogin')
        sessionStorage.removeItem('userEmail')
        sessionStorage.removeItem('userTaxId')
        sessionStorage.removeItem('reviewTermsEcs')
        this.$toast.success('Termos aceitos com sucesso.')

        try {
          await this.$router.replace('/')
        } catch (navigationError) {
          window.location.assign('/')
        }
      } catch (error) {
        this.errorMessage = 'Não foi possível registrar o aceite. Tente novamente.'
      } finally {
        this.loading = false
        callLoading(false)
      }
    },
  },
}
</script>

<style scoped lang="scss">
.terms-page {
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1.5rem;
  box-sizing: border-box;
  background: #f8f8f8;
  overflow: hidden;
}

.terms-container {
  width: 100%;
  max-width: 1100px;
  max-height: calc(100vh - 3rem);
  max-height: calc(100dvh - 3rem);
}

.terms-card {
  width: 100%;
  margin: 0;
  background-color: #fff;
  border: 0;
}

.brand-logo {
  display: inline-block;
  margin-bottom: 1rem;

  .logo-size {
    max-width: 100%;
    height: 28px;
    width: auto;
  }
}

.terms-content {
  width: 100%;
  height: 55vh;
  max-height: 600px;
  min-height: 300px;
  overflow-y: auto;
  overflow-x: auto;
  border: 1px solid #ebe9f1;
  border-radius: 4px;
  padding: 1.5rem;
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
}

.ecs-list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
}

.ecs-label {
  flex-basis: 100%;
  font-weight: 600;
}

.ecs-badge {
  white-space: normal;
  text-align: left;
}

@media (max-width: 991px) {
  .terms-page {
    padding: 1rem;
  }

  .terms-container {
    max-height: calc(100vh - 2rem);
    max-height: calc(100dvh - 2rem);
  }

  .terms-content {
    height: 55vh;
  }
}

@media (max-width: 767px) {
  .terms-page {
    align-items: flex-start;
    padding: 0.75rem;
    overflow-y: auto;
  }

  .terms-container {
    max-height: none;
  }

  .terms-card {
    padding: 0.25rem;
  }

  .brand-logo {
    margin-bottom: 0.75rem;
  }

  .terms-content {
    height: 50vh;
    min-height: 250px;
    padding: 1rem;
  }
}

@media (max-width: 480px) {
  .terms-page {
    padding: 0.5rem;
  }

  .terms-card {
    padding: 0;
  }

  .terms-content {
    height: 48vh;
    min-height: 220px;
    padding: 0.75rem;
  }
}
</style>